export default __webpack_public_path__ + "static/media/ic-bnb-bep20.9ef98a5c.svg";